<template>
	<section class="grid grid-cols-1 md:grid-cols-2 relative">
		<img :src="src" alt="Get color matched" class="w-full object-cover" />
		<div
			class="!px-4 !py-16 flex flex-col justify-end md:justify-center absolute inset-0 md:relative gap-4 items-center !container mx-auto !max-w-seint"
		>
			<color-match-share-link
				v-if="showShareLink"
				:affiliate-code="affiliateCode"
				class-name="relative mb-4 md:mb-0 right-0  fill-white md:fill-black"
			/>
			<h1 class="!m-0 !p-0 font-butler-light text-3xl/[38px] font-light !text-white md:!text-black">
				Get color matched
			</h1>
			<p class="!m-0 !p-0 text-sm text-center !text-white md:!text-black">
				Answer a few questions to get personalized recommendations in under 2 minutes
			</p>
			<button
				type="button"
				aria-label="Get started with color match"
				@click="handleNextStep"
				class="btn-primary-fg !mt-3 hidden md:flex h-12 w-[360px] flex-col items-center justify-center bg-black text-[11px]/[14px] uppercase"
			>
				Get Started
			</button>
			<button
				type="button"
				aria-label="Get started with color match"
				@click="handleNextStep"
				class="px-6 py-2 bg-white/10 backdrop-blur-md border-transparent text-white shadow-lg hover:bg-white/20 transition !mt-3 flex h-12 w-[360px] flex-col items-center justify-center bg-black text-[11px]/[14px] uppercase md:hidden"
			>
				Get Started
			</button>
		</div>
	</section>
</template>
<script setup>
const props = defineProps({
	affiliateCode: {
		type: String,
		default: null,
	},
	showShareLink: {
		type: Boolean,
		default: false,
	},
	setStep: {
		type: Function,
		required: true,
	},
})

const src = `https://s3.us-east-2.amazonaws.com/seint.com/color-match/color-match-bg.jpg`
const handleNextStep = () => props.setStep(1)
</script>
